import { Box, Button, Container, Grid } from '@mui/material'
import makeStyles from '@mui/styles/makeStyles'
import React from 'react'
import { useNavigate } from 'react-router'
import operationsIcon from '../../assets/svg/ws-b2b-icon-operations.svg'
import { ROUTE_OPERATIONS_CONTROL_CENTRE } from '../util/routes'

const useStyle = makeStyles((theme) => ({
  shuffleButton: {
    textTransform: 'none',
    fontSize: '1rem',
    width: '100%',
    marginTop: '15px',
    fontWeight: 'bold',
    height: 50,
  },
}))

interface IProps {}

const Operations: React.FC<IProps> = (props) => {
  const classes = useStyle()
  const navigate = useNavigate()

  return (
    <>
      <div id="main" className="section-entry">
        <Container className="page-header">
          <Grid container spacing={2} justifyContent="center">
            <Grid item xs={12}>
              <h1 className="settings-h1 centered-heading">Operations</h1>
            </Grid>
          </Grid>
        </Container>
      </div>
      <Container className="page-content">
        <Grid item xs={12}>
          <Grid container justifyContent="center" spacing={1}>
            <Box className="section-card">
              <div className="icon-box-wrapper">
                <img className="settings-self-reg" src={operationsIcon} alt="Self Registration" />
              </div>
              <h2>Control centre</h2>
              <p>Help your parkers get in and out of the car park.</p>
              <Button
                className={classes.shuffleButton}
                variant="contained"
                color="primary"
                size="large"
                onClick={() => navigate(ROUTE_OPERATIONS_CONTROL_CENTRE)}
              >
                Manage
              </Button>
            </Box>
          </Grid>
        </Grid>
      </Container>
    </>
  )
}

export default Operations
